export const isImage = file => {
  let extension = file;

  if (typeof file === 'object') {
    extension = file?.type || file?.fileType || file.documentExt;
  }

  return /^(jpeg|image\/jpeg|jpg|image\/jpg|png|image\/png)$/.test(extension);
};
